import { Controller } from 'stimulus'

// The K coefficient, shown next to the two that are typed and recomputed on
// every keystroke.
//
//     K = (1 + overhead coef) × sale coef
//     selling price = dry cost × K
export default class extends Controller {

  static targets = ['fg', 'sale', 'k']

  connect() { this.refresh() }

  refresh() {
    const fg   = this.parse(this.fgTarget.value)
    const sale = this.parse(this.saleTarget.value)

    // No sale coefficient set: there is no K to announce, the quote will fall
    // back on its own.
    this.kTarget.textContent = sale > 0 ? this.format((1 + fg) * sale) : '—'
  }

  parse(value) {
    const number = parseFloat(String(value).replace(',', '.'))
    return Number.isFinite(number) ? number : 0
  }

  // Three decimals, like the formatCoef of both tables: K is a product and
  // carries the precision of its two factors.
  format(value) {
    // toFixed rounds on the binary representation: 1.5525 drops to 1.552 there.
    const rounded = Math.round(Math.round(value * 100000) / 100) / 1000
    return rounded.toFixed(3).replace('.', ',')
  }
}
